<!-- 开发文档：http://knowledge.ark.burgeononline.com/repository#/entryComponents/2/907865/2/2061 -->
<template>
  <div>
    <OmsTable
      v-loading="loading"
      :jordan-table-config="tableConfig"
      @on-page-change="pageChange"
      @on-page-size-change="pageSizeChange"
      @on-current-change="radioChange"
      @on-select="onSelect"
      @on-select-cancel="onSelectCancel"
      @on-select-all="onSelectAll"
      @on-select-all-cancel="onSelectAllCancel"
    />
  </div>
</template>

<script>
import OmsTable from "./OmsTable.vue";
// import config from "@/js/pages/orderCenter/orderManageDetail/details/config.js";
const SubTable = {
  name: 'SubTable',
  data() {
    return {
      loading: false,
      tableConfig: {
        loadingShow: false,
        showHeader: true,
        columns: [],
        data: [],
        pageShow: true, // 控制分页是否显示
        btnsShow: true, // 控制操作按钮是否显示
        searchInputShow: false, // 控制搜索框是否显示
        indexColumn: true,
        width: "", // 表格宽度
        height: "", // 表格高度
        border: true, // 是否显示纵向边框
        total: 0, // 设置总条数
        pageSizeOpts: [10, 20, 30, 50, 100], // 每页条数切换的配置
        pageSize: 10, // 每页条数
        current: "", // 当前页
      },
      objid: "",
      options: {}, // 自定义属性（选填）
    };
  },
  components: {
    OmsTable,
  },
  props: {
    /**
     * componentData属性说明：
     * @centerName 一般为中心名,不传则默认是'orderCenter',用于匹配config文件的一级key
     * @tablename 当前明细表的表名
     * @objid 明细ID（这条详情的ID）
     * @pageShow 当前是否展示页码
     */
    componentData: {},
  },
  watch: {
    componentData: {
      handler(newVal) {
        this.request(newVal);
      },
    },
  },
  methods: {
    radioChange(current, old) {
      this.$emit('on-current-change', current, old)
    },
    onSelect(selection, row) {
      this.$emit('on-select', selection, row)
    },
    onSelectCancel(selection, row) {
      this.$emit('on-select-cancel', selection, row)
    },
    onSelectAll(selection) {
      this.$emit('on-select-all', selection)
    },
    onSelectAllCancel(selection) {
      this.$emit('on-select-all-cancel', selection)
    },
    pageChange(val) {
      this.tableConfig.current = val;
      this.request(this.componentData);
    },
    pageSizeChange(val) {
      this.tableConfig.pageSize = val;
      this.request(this.componentData);
    },
    async request(req) {
      const self = this;
      const centerName = req.centerName ? req.centerName : "orderCenter";
      /**
       * config配置信息
       * http://knowledge.ark.burgeononline.com/repository#/entryComponents/2/907865/2/2061
       */
      if (!self.config[centerName][req.tablename]) {
        console.warn("no Config in this.OMS.subTableConfig ！！！");
        console.warn('this.OMS.subTableConfig::', self.config);
        return;
      }
      const data = JSON.parse(
        JSON.stringify(self.config[centerName][req.tablename])
      ); // 匹配config文件中每个小item的key
      self.objid = req.objid || -1;
      // if (self.objid === -1) return;
      const searchdata = {};
      // console.log('this.tableConfig::', this.tableConfig, data);
      searchdata.startindex = (this.tableConfig.current - 1) * this.tableConfig.pageSize;
      searchdata.range = this.tableConfig.pageSize;
      data.searchdata = JSON.stringify(
        Object.assign(data.searchdata, searchdata, req.searchdata || {})
      );
      self.options = req.options || {};
      let refcolid = data.refcolid
      if (refcolid == 'async') {
        refcolid = await this.getObjectTab(data)
      }
      const _searchdata = JSON.parse(data.searchdata)
      if (!req.pageShow) {
        _searchdata.range = req.pageSize
      }
      const formdata = new FormData();
      formdata.append("objid", self.objid);
      formdata.append("table", data.table);
      formdata.append("searchdata", JSON.stringify(_searchdata));
      formdata.append("refcolid", refcolid);
      if (self.tableConfig.loadingShow) {
        self.loading = true
      }
      const res = await this.service.common.objectTableItem(formdata).catch(() => {
        console.error('p/cs/objectTableItem try catch !')
      });
      if (res.data.code === 0) {
        self.showTable(res.data.datas ? res.data.datas : res.data.data);
        self.$emit('reset-table')
      } else {
        // 数据加载失败
        // console.log(self.t('失败！'));
      }
      self.loading = false
    },
    async getObjectTab(data) {
        const formdata = new FormData();
        formdata.append('table', data.mainTableName);
        formdata.append('objid', -1);
        formdata.append('ismaintable', 'y');
        formdata.append('flag', +Date.now());
        return this.service.inventoryCenter.objectTab(formdata).then(res => {
          if (res.data.code === 0) {
            const reftabs = res.data.data.reftabs
            const y = reftabs.findIndex(i => i.tablename == data.table)
            if (y != -1) {
              return reftabs[y].refcolid
            } else {
              $fcError(`Failed to find associated table：${data.table}！`);
              throw new Error('没有配置关联表！')
            }
          }
        })
      },
    showTable(obj) {
      const thead = obj.tabth
        .filter((element) => {
          if (element.colname === "ID") return false;
          return true;
        })
        .map((element) => {
          const obj = {
            key: element.colname,
            title: element.name,
          };
          return obj;
        });
      const tbody = obj.row.map((row) => {
        const obj = {};
        for (const i in row) {
          obj[i] = row[i].val;
        }
        return obj;
      });
      let conf = {
        multiple: this.componentData.hasOwnProperty('isShowSelection') ? this.componentData.multiple : true,
        highlightRow: this.componentData.highlightRow || false,
        showHeader: true,
        columns: thead,
        data: tbody,
        pageShow: this.componentData.pageShow || false, // 控制分页是否显示
        loadingShow: this.componentData.loadingShow || false, // 控制切换分页时展示loading
        btnsShow: true, // 控制操作按钮是否显示
        searchInputShow: false, // 控制搜索框是否显示
        indexColumn: true,
        isShowSelection: this.componentData.hasOwnProperty('isShowSelection') && this.componentData.isShowSelection,
        width: "", // 表格宽度
        height: this.componentData.height || '', // 表格高度
        border: true, // 是否显示纵向边框
        total: obj.totalRowCount, // 设置总条数
        pageSizeOpts: this.componentData.hasOwnProperty('isShowSelection') ? this.componentData.pageSizeOpts : obj.selectrange, // 每页条数切换的配置
        pageSize: obj.defaultrange, // 每页条数
      }
      if (!this.componentData.pageShow) {
        // conf.pageSize = this.componentData.pageSize // 会导致触发pageChange
        delete conf.pageSizeOpts
        delete conf.pageSize
      }
      this.tableConfig = conf;
    },
  },
  created() {
    const _this = this;
    _this.config = this.OMS.subTableConfig;
  },
  mounted() {
    if (this.componentData && this.componentData.tablename) {
      this.$nextTick(() => {
        this.request(this.componentData);
      })
    }
  },
};
export default SubTable
</script>
